export default {
  VERIFICATION: 'verification',
  PROFILE: 'profile',
};
